/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coinvestments_Dataroom_Replacefiles_Description3Inputs */

const en_coinvestments_dataroom_replacefiles_description3 = /** @type {(inputs: Coinvestments_Dataroom_Replacefiles_Description3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} files with the same name already exist in this folder.`)
};

/**
* | output |
* | --- |
* | "{count} files with the same name already exist in this folder." |
*
* @param {Coinvestments_Dataroom_Replacefiles_Description3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_replacefiles_description3 = /** @type {((inputs: Coinvestments_Dataroom_Replacefiles_Description3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Replacefiles_Description3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_replacefiles_description3(inputs)
});
export { coinvestments_dataroom_replacefiles_description3 as "coInvestments_dataRoom_replaceFiles_description" }